module.exports = __webpack_public_path__ + "static/about-0f2c7651bd6d486fe1b253d8e6edbc6e.jpeg";